<div
  class="list"
  [class.loading-block]="isLoading()"
  [class.item-clicked]="isMouseDown() || hasChildMouseDown()"
  cdkDropList
  [id]="folderId()"
  [cdkDropListDisabled]="disableDrag()"
  [cdkDropListData]="items()"
  [cdkDropListEnterPredicate]="evenPredicate"
  [cdkDropListConnectedTo]="folderIds()"
  [cdkDropListAutoScrollStep]="10"
  (cdkDropListDropped)="drop.emit($event)">
  @for (item of items(); track item.id) {
    <div
      class="list-item-wrapper"
      cdkDrag
      [attr.data-node-id]="item.id"
      [cdkDragData]="item"
      [cdkDragDisabled]="disableDrag()"
      (cdkDragStarted)="onDragStarted()"
      (cdkDragEnded)="onDragEnded()">
      @if (item.type === "document") {
        <a
          clickOrDoubleClick
          class="list-item gap-2"
          [class.collapsed]="collapsed()"
          [class.active]="isDefaultMode() && isDocumentActive(item.id)"
          (click)="!hasContextMenu() && onDocumentSingleClick(item, $event)"
          (singleClick)="hasContextMenu() && onDocumentSingleClick(item, $event)"
          (doubleClick)="onDocumentDoubleClick(item.id, $event)"
          (mousedown)="onMouseDown($event)">
          <custom-icon name="fileText" class="icon-secondary" [size]="20" viewBox="0 0 20 20" />
          @if (!collapsed()) {
            <div class="list-item-title">
              <span class="text-truncate">
                {{ item.title }}
              </span>

              @if (item.isPublic && allowPublicBadge()) {
                <span class="badge badge-info">Public</span>
              }

              @if (item.isSharedWithMe && allowPublicBadge()) {
                <span class="badge bg-info">Shared</span>
              }

              @if (!item.isSharedWithMe && item.hasAnyShare && allowPublicBadge()) {
                <span class="badge bg-info">Shared</span>
              }
            </div>
          }

          @if (isPickerMode()) {
            <input
              type="checkbox"
              [checked]="selectedDocumentsMap()?.has(item.id)"
              (change)="onToggleSelection(item)"
              (click)="$event.stopPropagation()" />
          }

          @if (hasContextMenu() && !collapsed()) {
            <component-document-context-menu
              [entity]="item"
              [canDrag]="!disableDrag()"
              [canMove]="!disableMove()"
              [isInPublicFolder]="isInPublicFolder()"
              (entityUpdated)="entityUpdated.emit($event)"
              (documentDeleted)="documentDeleted.emit($event)"
              (duplicateDocument)="duplicateDocument.emit($event)"
              (entityMoved)="entityMoved.emit($event)"
              (treeUpdated)="treeUpdated.emit($event)" />
          }
        </a>
      }

      @if (item.type === "folder") {
        <component-folder-node
          [item]="item"
          [folderIds]="folderIds()"
          [isPublicView]="isPublicView()"
          [disableDrag]="disableDrag()"
          [disableMove]="disableMove()"
          [expandAll]="expandAll()"
          [collapsed]="collapsed()"
          [isInPublicFolder]="isInPublicFolder()"
          [isCreateDisabled]="isCreateDisabled()"
          [hasContextMenu]="hasContextMenu()"
          [allowPublicBadge]="allowPublicBadge()"
          [mode]="mode()"
          [(selectedDocumentsMap)]="selectedDocumentsMap"
          (entityUpdated)="entityUpdated.emit($event)"
          (documentDeleted)="documentDeleted.emit($event)"
          (duplicateDocument)="duplicateDocument.emit($event)"
          (folderDelete)="folderDelete.emit($event)"
          (entityMoved)="entityMoved.emit($event)"
          (treeUpdated)="treeUpdated.emit($event)"
          (documentCreate)="documentCreate.emit($event)"
          (drop)="drop.emit($event)" />
      }
    </div>
  } @empty {
    @if (isLoading() && !emptyMessage()) {
      <div class="p-3 text-muted">Searching...</div>
    } @else if (emptyMessage()) {
      <div class="p-3 text-muted">{{ emptyMessage() }}</div>
    }
  }
  @if (isLoading() && items().length > 0) {
    <div class="p-3 text-muted">Searching...</div>
  }
</div>
